<template>
    <div>
        <div class="d-flex align-center mb-1">

            <v-btn
                color="secondary"
                text
                small
                rounded
                @click="showCreateDialog"
            >
                <v-icon class="mr-2">mdi-plus-circle-outline</v-icon>
                Nowy tag
            </v-btn>

        </div>

        <v-divider></v-divider>

        <loading-message v-if="tagIndexing" message="Pobieranie listy tagów..." class="my-5"></loading-message>

        <v-simple-table v-else-if="tags.length">
            <template v-slot:default>
                <tbody>
                <tr
                    v-for="tag in tags"
                    :key="tag.TagID"
                >
                    <th class="text-no-wrap">
                        {{ tag.Content }}
                    </th>
                    <td class="text-right">

                        <v-menu
                            bottom
                            left
                            :offset-y="true"
                            rounded
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    small
                                    icon
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>

                            <v-list dense>
                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showEditDialog(tag)"><v-icon small>mdi-folder-edit-outline</v-icon> Edytuj</a>
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item>
                                    <v-list-item-title>
                                        <a @click="showDeleteDialog(tag)"><v-icon small>mdi-delete-outline</v-icon> Usuń</a>
                                    </v-list-item-title>
                                </v-list-item>

                            </v-list>
                        </v-menu>

                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-alert
            v-else
            class="mt-5"
            border="left"
            colored-border
            type="info"
            elevation="1"
        >Brak dodanych tagów</v-alert>

        <v-dialog
            v-model="tagCreateDialog"
            persistent
            width="500"
        >
            <v-card>
                <v-card-title class="headline grey lighten-2 mb-5">
                    Nowy tag
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideCreateDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="tagForm.Content"
                        label="Tag*"
                        maxlength="64"
                        :counter="64"
                        :error="$store.getters.hasValidationError('Content')"
                        :error-messages="$store.getters.validationError('Content')"
                    ></v-text-field>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="tagStore"
                        :loading="tagStoring"
                    >DODAJ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="tagEditDialog"
            persistent
            width="500"
        >
            <v-card v-if="tagToEdit">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Edycja tagu
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideEditDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="tagForm.Content"
                        label="Tag*"
                        maxlength="64"
                        :counter="64"
                        :error="$store.getters.hasValidationError('Content')"
                        :error-messages="$store.getters.validationError('Content')"
                    ></v-text-field>
                    <small>* pole wymagane</small>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        rounded
                        color="success"
                        @click="tagUpdate"
                        :loading="tagUpdating"
                    >ZAPISZ</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="tagDeleteDialog"
            persistent
            width="500"
        >
            <v-card v-if="tagToDelete">
                <v-card-title class="headline grey lighten-2 mb-5">
                    Usuwanie tagu
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        @click="hideDeleteDialog"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text>
                    Czy na pewno chcesz usunąć tag
                    <strong>{{tagToDelete.Content}}</strong>?
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        rounded
                        @click="tagDelete(tagToDelete)"
                        :loading="tagDeleting"
                    >Usuń</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingMessage from "../../../components/LoadingMessage";

export default {
    name: "Tags",

    components: {
        LoadingMessage,
    },

    data () {
        return {
            tagIndexing: false,
            tags: [],

            tagCreateDialog: false,
            tagStoring: false,

            tagEditDialog: null,
            tagToEdit: null,
            tagUpdating: false,

            tagDeleteDialog: false,
            tagToDelete: null,
            tagDeleting: false,

            tagForm: {
                Content: null,
            },
        };
    },

    methods: {
        tagIndex: function () {
            this.tagIndexing = true;

            this.$store.dispatch('tagIndex')
                .then(response => {
                    if (response.status === 200) {
                        this.tags = response.data.data;
                    } else {
                        this.$store.commit("showSnackbarError", "Błąd wczytywania tagów.");
                    }
                })
                .catch(error => {})
                .then(() => {
                    this.tagIndexing = false;
                });
        },
        tagStore: function () {
            this.tagStoring = true;

            this.$store.dispatch('tagStore', this.tagForm).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideCreateDialog();
                    this.$store.commit("showSnackbarSuccess", "Dodano tag.");
                    this.tagIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu tagu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.tagStoring = false;
                });
        },
        tagUpdate: function () {
            this.tagUpdating = true;

            this.$store.dispatch('tagUpdate', {
                TagID: this.tagToEdit.TagID,
                formData: this.tagForm
            }).then(response => {
                if ([200, 201].includes(response.status)) {
                    this.hideEditDialog();
                    this.$store.commit("showSnackbarSuccess", "Zapisano zmiany w tagu.");
                    this.tagIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd zapisu tagu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.tagUpdating = false;
                });
        },
        tagDelete: function (tag) {
            this.tagDeleting = true;

            this.$store.dispatch('tagDelete', tag.TagID).then(response => {
                if (response.status === 204) {
                    this.hideDeleteDialog();
                    this.$store.commit("showSnackbarSuccess", "Usunięto tag.");
                    this.tagIndex();
                } else {
                    this.$store.commit("showSnackbarError", "Błąd usuwania tagu.");
                }
            })
                .catch(error => {})
                .then(() => {
                    this.tagDeleting = false;
                });
        },
        showCreateDialog: function () {
            this.tagCreateDialog = true;
        },
        hideCreateDialog: function () {
            this.tagCreateDialog = false;
            this.resetTagForm();
            this.$store.commit("resetValidation");
        },
        showEditDialog: function (tag) {
            this.tagToEdit = tag;
        },
        hideEditDialog: function () {
            this.tagEditDialog = false;
        },
        showDeleteDialog: function (tag) {
            this.tagToDelete = tag;
        },
        hideDeleteDialog: function () {
            this.tagDeleteDialog = false;
        },
        resetTagForm: function () {
            for (const index in this.tagForm) {
                this.tagForm[index] = null;
            }
        },
        setTagForm: function (tag) {
            this.tagForm.Content = tag.Content;
        },
    },
    created() {
        this.tagIndex();
    },
    watch: {
        tagToEdit: function (tag) {
            if(tag !== null) {
                this.setTagForm(tag);
                this.tagEditDialog = true;
            }
        },
        tagEditDialog: function (visible) {
            if(!visible) {
                this.resetTagForm();
                this.$store.commit("resetValidation");
                this.tagToEdit = null;
            }
        },
        tagToDelete: function (tag) {
            if(tag !== null) {
                this.tagDeleteDialog = true;
            }
        },
        tagDeleteDialog: function (visible) {
            if(!visible) {
                this.tagToDelete = null;
            }
        },
    },
}
</script>
